import React, { useCallback } from 'react';
import { useTheme } from '@material-ui/core';
import { useTrimLevel } from '../../../../trimLevels/contexts/TrimLevelContext';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';
import Translation from '../../translation/Translation';

const useNavigationLabel = (isGraphql?: boolean, withTranslation?: boolean) => {
  const {
    spc: {
      trimLevels: { isVariantsTitleSplit, showNavLabel },
    },
  } = useTheme<ISpcTheme>();
  const { modelName } = useTrimLevel();

  const getTranslationLabel = useCallback(
    (label: string, className?: string) => (
      <Translation
        id="trans__configurator__variants_page__title"
        values={{ model: <span className={className}>{label}</span> }}
      />
    ),
    [],
  );

  const renderLabel = useCallback(
    (label: string, name: string, trimLabel?: string, className?: string) => {
      if (modelName) {
        return getTranslationLabel(modelName, className);
      }

      if (isVariantsTitleSplit && trimLabel) {
        return getTranslationLabel(trimLabel, className);
      }

      if (!withTranslation && label && (!isVariantsTitleSplit || showNavLabel)) {
        return label;
      }

      return (
        <Translation
          id={isGraphql ? `trans__configurator__customise_page_banner__${name}` : `spc.common.navigation.${name}`}
        />
      );
    },
    [isGraphql, withTranslation, modelName, isVariantsTitleSplit, showNavLabel],
  );

  return {
    getTranslationLabel,
    renderLabel,
  };
};

export default useNavigationLabel;
